import { groupBy } from 'lodash';
import { Box } from '@mui/material';
import { toastConfig } from 'config';
import { App, Spin } from 'antd';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import React, { useEffect, useMemo } from 'react';
import { TableStatusMap } from 'pages/globals/global';
import controls from 'assets/images/icons/deactivated.svg';
import EditIconButton from 'components/button/EditIconButton';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import FileViewIconButton from 'components/button/FileViewIconButton';
import FileDeleteIconButton from 'components/button/FileDeleteIconButton';
import ComptrollerDataTable from '../comptroller-table/ComptrollerDataTable';
import { useActivationEntityMutation } from 'store/features/process/processApi';

function ListViewGraph({ navigate, setReloadTable, graphTable = [], isLoading }) {
	const { message: messageApi } = App.useApp();
	const [value, setValue] = React.useState(null);
	const [ActivationEntity, { data: activationEntity }] = useActivationEntityMutation();
	const [rowSelection, setRowSelection] = React.useState({});
	const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
	const { profileData } = useSelector((state) => state?.profile);
	const [showModal, setShowModal] = React.useState(false);
	const [submitForm, setSubmitForm] = React.useState(false);
	const [modalData, setModalData] = React.useState({});
	const [submitData, setSubmitData] = React.useState(null);
	const [actionValue, setActionValue] = React.useState(null);

	useEffect(() => {
		if (rowSelection?.length) {
			let arr = [];
			rowSelection?.map((item) => {
				arr.push(item.original);
				return item;
			});
			setSelectedRowKeys(groupBy(arr, ({ entityStatus }) => entityStatus));
		}
	}, [rowSelection]);
	useEffect(() => {
		if (submitData && submitForm) {
			submitData?.map((item) => {
				ActivationEntity(item);
				return item;
			});
		}
	}, [submitForm]);

	useEffect(() => {
		if (activationEntity && value === activationEntity?.entityStatus) {
			let message =
				submitData?.length > 1 ? `Success! ${submitData?.length} rows ${actionValue}` : `Success! ${submitData?.length} row ${actionValue}`;
			toast.success(message, toastConfig);
			setReloadTable((val) => !val);
			setSubmitForm(false);
			setSubmitData(null);
		} else if (activationEntity && value !== activationEntity?.entityStatus) {
			toast.error('Entity Status Updation Error!', toastConfig);
		}
		//eslint-disable-next-line
	}, [activationEntity]);

	const activeDeactiveHandle = (entityStatus) => {
		let arr = [];
		if (entityStatus === 'Active') {
			setValue('Inactive');
			setActionValue('deactivated');
			setModalData({
				head: 'Entity',
				// action: rowSelection?.length > 1 ? "deactivate all" : "deactivate"
				label:
					rowSelection?.length > 1 ? (
						<p>
							{' '}
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> this entity?
						</p>
					),
			});
			if (selectedRowKeys[entityStatus]) {
				selectedRowKeys[entityStatus]?.map((item) => {
					arr.push({
						id: item?.id,
						companyCode: profileData?.creatorOrganizationId,
						parent: item?.parent ?? '',
						code: item?.code,
						name: item?.name,
						entityStatus: 'Inactive',
					});
					return item;
				});
			}
		} else if (entityStatus === 'Inactive') {
			setValue('Active');
			setActionValue('activated');
			setModalData({
				head: 'Entity',
				label:
					rowSelection?.length > 1 ? (
						<p>
							{' '}
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> this entity?
						</p>
					),
			});
			if (selectedRowKeys[entityStatus]) {
				selectedRowKeys[entityStatus]?.map((item) => {
					arr.push({
						id: item?.id,
						companyCode: profileData?.creatorOrganizationId,
						parent: item?.parent ?? '',
						code: item?.code,
						name: item?.name,
						entityStatus: 'Active',
					});
					return item;
				});
			}
			if (selectedRowKeys['Onboarded']) {
				selectedRowKeys['Onboarded']?.map((item) => {
					arr.push({
						id: item?.id,
						companyCode: profileData?.creatorOrganizationId,
						parent: item?.parent ?? '',
						code: item?.code,
						name: item?.name,
						entityStatus: 'Active',
					});
					return item;
				});
			}
		}
		if (arr?.length !== rowSelection?.length) {
			messageApi.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setSubmitData(arr);
			setShowModal(true);
		}
	};

	// ==============================|| TABLE - HEADER ||============================== //

	// set active and inactive status with color

	const activeInactiveStatus = (status) => {
		if (status === 'Active') {
			return (
				<Box
					style={{
						// backgroundColor: '#DBF7E2', color: '#30653D',
						textAlign: 'center',
						borderRadius: '5px',
						padding: '2px',
					}}
				>
					{status}
				</Box>
			);
		} else if (status === 'Inactive') {
			return (
				<Box
					style={{
						// backgroundColor: '#FFE2E2', color: '#BB2222',
						textAlign: 'center',
						borderRadius: '5px',
						padding: '2px',
					}}
				>
					{status}
				</Box>
			);
		} else if (status === 'W-I-P') {
			return (
				<Box
					style={{
						// backgroundColor: '#FDF7C4', color: '#694500',
						textAlign: 'center',
						borderRadius: '5px',
						padding: '2px',
					}}
				>
					{status}
				</Box>
			);
		}
	};

	const COLUMNS = useMemo(
		() => [
			// {
			//   id: "Selection",
			//   Header: ({ getToggleAllRowsSelectedProps }) => <IndeterminateCheckbox sx={{ color: "white", padding: "0px" }} {...getToggleAllRowsSelectedProps()} />,
			//   Cell: ({ row, index }) => <IndeterminateCheckbox id={index} {...row.getToggleRowSelectedProps()} />,
			//   onClicked: true,
			//   align: "center",
			//   cellAlign: "center",
			// },

			{
				Header: 'Name',
				accessor: 'graphName',
			},
			{
				Header: 'Description',
				accessor: 'graphDescription',
			},
			{
				Header: 'Type',
				accessor: 'graphType',
			},
			{
				Header: 'Status',
				accessor: (data) => {
					return TableStatusMap[data?.activationStatus];
				},
				Cell: (cell) => {
					return activeInactiveStatus(TableStatusMap[cell.row.original.activationStatus]);
					// return TableStatusMap[cell.row.original.entityStatus] === "Active" ? <Box style={{ backgroundColor: "#DBF7E2", color: "#30653D", textAlign: "center", borderRadius: "5px", padding: "2px", display: "flex", justifyContent: "center" }}>{TableStatusMap[cell.row.original.entityStatus]}</Box> : <Box style={{ backgroundColor: "#FFE2E2", color: "#BB2222", textAlign: "center", borderRadius: "5px", padding: "2px", display: "flex", justifyContent: "center" }}>{TableStatusMap[cell.row.original.activationStatus]}</Box>;
				},
				// align: 'center',
				cellAlign: 'center',
			},
			{
				Header: 'Action',
				Cell: (cell) => (
					<div style={{ textAlign: 'center' }}>
						<FileViewIconButton
							onClick={() => {
								navigate('/comptroller/graph-defination/view', { state: { id: cell.row.original.id } });
							}}
						/>

						<EditIconButton
							onClick={() => {
								navigate('/comptroller/graph-defination/edit', { state: { id: cell.row.original.id } });
							}}
						/>

						<FileDeleteIconButton
							onClick={(e) => {
								e.stopPropagation();
							}}
						/>

						{/* <Tooltip title="View">
							<Button
								type="text"
								icon={<img src={viewIcon} width={16} height={16} alt="view" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/comptroller/graph-defination/view', { state: { id: cell.row.original.id } });
								}}
							></Button>
						</Tooltip> */}

						{/* <Tooltip title="Edit">
							<Button
								type="text"
								icon={<img src={editIcon} width={16} height={16} alt="edit" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/comptroller/graph-defination/edit', { state: { id: cell.row.original.id } });
								}}
							></Button>
						</Tooltip>
						<Tooltip title="Delete">
							<Button
								type="text"
								icon={<img src={deleteIcon} width={16} height={16} alt="delete" />}
								onClick={(e) => {
									e.stopPropagation();
								}}
							></Button>
						</Tooltip> */}
					</div>
				),
				disableSortBy: 'true',
				align: 'center',
			},
		], //eslint-disable-next-line
		[]
	);

	return (
		<Spin spinning={isLoading}>
			<ComptrollerDataTable
				DATA={graphTable}
				onClickHandler={(row) => {
					navigate('/comptroller/graph-defination/view', { state: { id: row.id } });
				}}
				COLUMNS={COLUMNS}
				xlsxFileName="graph_defination"
				setRowSelection={setRowSelection}
				rowSelection={rowSelection}
				activeDeactivateHandle={activeDeactiveHandle}
			/>
			{showModal && (
				<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} setSubmitForm={setSubmitForm} modalData={modalData} />
			)}
		</Spin>
	);
}

export default ListViewGraph;